export default __webpack_public_path__ + "static/media/je.3a28ea4b.svg";